import { get } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showMemberProfile } from '../../actions/one-app';

const OneAppProfileLink = ({ showMemberProfile, ...otherProps }) => (
  <span {...otherProps} onClick={showMemberProfile} />
);

OneAppProfileLink.propTypes = {
  showMemberProfile: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch, { user }) =>
  bindActionCreators(
    {
      showMemberProfile: () => showMemberProfile({ siteMemberId: get(user, 'siteMemberId') }),
    },
    dispatch,
  );

export default connect(undefined, mapDispatchToProps)(OneAppProfileLink);
